import React from 'react';
import { getRandomIcon } from '../../domain/icons-provider';
import { rootActions, useAppDispatch, useAppSelector } from '../../data/store';

const RandomizeButton = () => {

    const dispatch = useAppDispatch();
    const iconsData = useAppSelector(store => store.root.iconsData);
    const category = useAppSelector(store => store.root.category);
    const randomizedButtonShaking = useAppSelector(store => store.root.randomizedButtonShaking);

    const randomize = async () => {
        const updatedIcon = await getRandomIcon(iconsData, category);
        dispatch(
            rootActions.main({
                randomIcon: updatedIcon,
                randomizedButtonShaking: false,
            })
        );
    };

    return (
        <button
            type="button"
            className={ `bg-red-700 hover:bg-red-800 text-gray-100 rounded-full px-12 py-3 text-xl whitespace-nowrap transition duration-150 ease-out hover:ease-in ${ randomizedButtonShaking ? 'shake-animation' : '' }` }
            onClick={ randomize }>Randomize</button>
        )
    };

export default RandomizeButton;